import * as React from 'react'

import { useFinancialsTableContext } from '../../components/financials-table'
import { EarningsSettings } from './types'

export function TempRenameSettingsProperties({
  defaultSettings,
  keysReplace,
}: {
  defaultSettings: Record<string, unknown>
  keysReplace: Array<[string, string]>
}) {
  const { settings, setSettings } = useFinancialsTableContext<EarningsSettings>()

  React.useEffect(() => {
    const oldKeys = keysReplace.map((keyPair) => keyPair[0])
    const hasOldKey = Object.keys(settings).some((settingKey) => oldKeys.includes(settingKey))

    if (hasOldKey) {
      setSettings(
        Object.keys(defaultSettings as EarningsSettings).reduce((acc, key) => {
          let valueKey = key
          const replaceKeyPair = keysReplace.find((keyPair) => keyPair[1] === key)

          if (replaceKeyPair) {
            valueKey = replaceKeyPair[0]
          }
          return {
            ...acc,
            [key]: settings[valueKey as keyof typeof settings] ?? defaultSettings[key],
          }
        }, {} as EarningsSettings)
      )
    }
    // We want to run it on mount only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
